// src/context/ErrorContext.js
import React, { createContext, useContext, useState } from 'react';
import { toast } from 'react-toastify';

const ErrorContext = createContext();

export function ErrorProvider({ children }) {
  const [error, setError] = useState(null);

  const showError = (message) => {
    setError(message);
    toast.error(message, {
      autoClose: 5000, // Auto-close after 5 seconds
    });
  };

  const clearError = () => {
    setError(null);
  };

  return (
    <ErrorContext.Provider value={{ error, showError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
}

export const useError = () => useContext(ErrorContext);